/**
 * Utility to extract family and index from damage family string
 * Ported from WarYes
 */
export default function extractDamageFamilyProperties(
  familyIndexString: string
) {
  return {
    family: familyIndexString.split('-')[0],
    index: Number(familyIndexString.split('-')[1]) - 1,
  };
}

